export const API_ENDPOINTS = {
    REQUESTS_ALL: 'requests/all',
    REQUESTS_EXPORT: 'requests/exportxls',
    REQUESTS_DELETE: 'requests',
    REQUESTS_DICTIONARY: 'requests/dictionary',
    REQUESTS_TRIMESTERS: 'requests/trimesters',
    REQUESTS_STATUS: 'requests/status',
    BRANCHES_ALL: 'branches',
    COMPANIES_ALL: 'companies/all',
    SUBSCRIPTORS_ALL: 'subscriptors/all',
    MASSIVE_UPLOADS: 'massiveUploads',
};